<div class="settings-roles">
  <div class="header">
    <span class="header__spacer"></span>
    <button mat-button color="primary" class="header__add-role-btn" (click)="openAddDialog()">
      <span>{{ 'shop-settings.roles.addButton' | translate }}</span>
      <mat-icon class="add-icon">add</mat-icon>
    </button>
  </div>
  <div class="settings-roles__part">
    <div class="table-wrapper">
      @if (isUpdatingRoles()) {
        <div class="loading-overlay">
          <mat-progress-spinner mode="indeterminate" diameter="40" />
        </div>
      }

      <table
        mat-table
        [dataSource]="isLoading() ? skeletonRows() : roles()"
        class="full-width-table"
        matSort
      >
        @for (column of columnsConfig; track column.name) {
          <ng-container [matColumnDef]="column.name">
            <th [class]="column.headerClass" mat-header-cell *matHeaderCellDef>
              {{ column.label | translate }}
            </th>
            <td [class]="column.cellClass" mat-cell *matCellDef="let role">
              @if (isLoading()) {
                @if (column.kind === 'actions') {
                  <div class="skeleton skeleton--icon"></div>
                } @else {
                  <div
                    class="skeleton skeleton--text"
                    [class.skeleton--short]="column.kind === 'users'"
                  ></div>
                }
              } @else {
                @if (column.kind === 'users') {
                  <button
                    class="user-count-btn"
                    [matMenuTriggerFor]="userMenu"
                    [class.menu-open]="menuTrigger.menuOpen"
                    #menuTrigger="matMenuTrigger"
                    mat-button
                    [disabled]="role.userCount === 0"
                  >
                    {{ role.userCount }}
                  </button>
                  <mat-menu #userMenu="matMenu" class="users-menu">
                    @for (user of role.users; track user.id) {
                      <span mat-menu-item disabled>{{ user.firstName }} {{ user.lastName }}</span>
                    }
                  </mat-menu>
                } @else if (column.kind === 'actions') {
                  @if (role.name !== ADMIN_ROLE) {
                    <button
                      class="cell"
                      mat-icon-button
                      [matMenuTriggerFor]="menu"
                      #menuTrigger="matMenuTrigger"
                    >
                      <mat-icon [class.menu-open]="menuTrigger.menuOpen">more_vert</mat-icon>
                    </button>
                    <mat-menu #menu="matMenu" class="roles-menu">
                      <button
                        mat-menu-item
                        (click)="tryToHandleRoleModification(role, openEditDialog.bind(this))"
                      >
                        <app-icon class="icon" [icon]="IconName.PENCIL" />
                        {{ 'shop-settings.roles.actions.edit' | translate }}
                      </button>

                      <button
                        mat-menu-item
                        (click)="tryToHandleRoleModification(role, onDelete.bind(this))"
                      >
                        <app-icon class="icon" [icon]="IconName.TRASH" />
                        {{ 'shop-settings.roles.actions.delete' | translate }}
                      </button>
                    </mat-menu>
                  }
                } @else if (column.name === 'description') {
                  <div class="description-cell">
                    {{ role[column.name] }}
                  </div>
                } @else {
                  {{ role[column.name] }}
                }
              }
            </td>
          </ng-container>
        }

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
  </div>
  <div class="settings-roles__footer footer">
    @if (!isLoading() && settingsRolesPagination().totalItems > 0) {
      <app-table-pagination
        [pagination]="settingsRolesPagination()"
        (pageChange)="handlePageChange($event)"
        (pageSizeChange)="handlePageSizeChange($event)"
      />
    }
  </div>
</div>
